<template>
  <Modal
    width="920"
    title="事件管理优化目标类型选择及校验"
    class-name="vertical-center-modal"
    v-model="state"
    :closable="false"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="show"></Spin>
    <div class="c-convert">
      <!-- 转换列表 -->
      <div class="c-convert-table">
        <dl class="c-table-thead">
          <dt style="width: 25%">账号</dt>
          <dt style="width: 45%">类型</dt>
          <dt style="width: 15%">是否可用</dt>
        </dl>
        <div class="c-convert-body">
          <dl class="item-account">
            <dd v-for="(account, index) of success_d" :key="account.id" :class="{ on: account.index === current }" @click="current = index">
              <span>{{ account.name }}</span>
              <span v-if="typeof account.convert_idx === 'number'" style="color: #ff4400; padding-left: 4px"> (已选)</span>
            </dd>
          </dl>
          <ul class="item-group">
            <RadioGroup :value="convertIdx" style="width: 100%" @on-change="changeConvertIdx">
              <li v-for="(conv, i) of converteies" :key="i">
                <Radio :label="i" class="item-group-dd">
                  {{ conv.external_action | convType }}{{ conv.deep_external_action | convDeepType }}
                  <!-- <span v-if="conv.deep_external_action === 'AD_CONVERT_TYPE_PURCHASE_ROI'" style="color:#ff4400;padding-left:18px;font-size:12px;display:block">
                    (白名单功能，未开通的账号请勿选择，否则会报错）
                  </span> -->
                </Radio>
                <dd class="item-group-dd dd-child">
                  <span v-if="conv.isExists">可用</span>
                  <span v-else class="g-error-text">不可用</span>
                </dd>
              </li>
            </RadioGroup>
          </ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="c-convert-footer">
      <Button type="default" @click="$emit('input', false)">返回上一步</Button>
      <Button type="default" v-if="btnRetry" @click="resizeConvert">重试</Button>
      <Button type="primary" @click="next" :disabled="!Boolean(btnSuccess)">确认并下一步</Button>
    </div>
  </Modal>
</template>
<script>
import { setSession, setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, deepCopy } from '@/common/js/utils'
import { getJuLiangPlusGoalsList } from '@/api/toutiao.local.model'
export default {
  name: 'deepGoal',
  props: {
    value: {
      type: Boolean
    },
    accounts: {
      type: Array
    },
    platform: {
      type: Number
    },
    gameId: {
      type: [Number, String]
    },
    landingType: {
      type: String
    },
    packageName: {
      type: String
    },
    appPromotionType: {
      type: String
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    converteies() {
      let convert = []
      if (this.success_d.length) convert = this.success_d.filter((ret) => ret.index === this.current).pop().converter
      return convert
    },
    convertIdx() {
      let idx = ''
      if (this.success_d.length) idx = this.success_d.filter((ret) => ret.index === this.current).pop().convert_idx
      return idx
    }
  },
  watch: {
    convert_source_type(nVal) {
      this.resizeConvert()
    },
    convert_type(nVal) {
      this.resizeConvert()
    }
  },
  methods: {
    bindGetData(val) {
      if (val) this.resizeConvert()
      else {
        // 还原默认值
        this.app_id = null
        this.deep_external_action = 0
        this.convert_type = 'AD_CONVERT_TYPE_ACTIVE' // 转化类型
        this.convert_source_type = 'AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD' // 转化来源
      }
    },
    changSourceType() {
      this.convert_type = 'AD_CONVERT_TYPE_ACTIVE'
      this.deep_external_action = 0
    },
    changeConvertIdx(index) {
      this.$set(this.success_d[this.current], 'convert_idx', index)
    },
    // 切换转化项 更新转化状态
    resizeConvert(val) {
      if (isArray(this.accounts) && this.accounts.length) {
        this.preCheckGoal((data) => {
          if (isArray(data)) {
            // 所有账号
            this.accounts.map((ret, index) => {
              ret.index = index
              ret.convert_idx = getLocal('converter') ? getLocal('converter')[ret.id] : '' // 取本地存储
              ret.converter = data.filter((met) => met.accountId === ret.id)
              return ret
            })
            this.btnSuccess = this.accounts.some((ret) => ret.converter.some((r) => r.isExists))
            this.btnRetry = data.some((ret) => !ret.isExists)
            this.success_d = deepCopy(this.accounts)
          } else this.success_d = []
        })
      } else this.$Message.error('未选择账号')
    },
    // 验证账号是否转化
    preCheckGoal(fn) {
      // 获取可用优化目标 媒体接口 https://open.oceanengine.com/labels/7/docs/1740944984250381
      const params = this.accounts.map((ret) => {
        const res = {
          ad_account_id: ret.id,
          landing_type: this.landingType,
          // (安卓)和(小程序+微端) landingType === APP
          asset_type: this.landingType === 'APP' ? 'APP' : 'ORANGE',
          ad_type: 'ALL',
          package_name: this.packageName
        }
        if (this.appPromotionType === 'RESERVE') {
          res.app_promotion_type = this.appPromotionType
        }
        if (res.asset_type === 'APP') {
          // 小程序 微端推广目的，app_type  设置为安卓
          res.app_type = this.platform === 1 || this.platform === 3 ? 'ANDROID' : 'IOS'
        }
        return res
      })
      this.show = true
      getJuLiangPlusGoalsList(params).then((data) => {
        this.show = false
        fn(data)
        // fn(testData)
      })
    },
    inputTrim(key) {
      const val = this[key]
      if (isEmpty(val)) return val
      this[key] = isEmpty(Number(val)) ? '' : Number(val)
    },
    next() {
      let index
      // 验证转化没选
      const convertx = this.success_d.some((ret, i) => {
        index = i
        return isEmpty(ret.convert_idx)
      })
      if (convertx) {
        this.$Message.warning('账号事件管理优化目标不能为空')
        this.current = index
        return
      }
      // 验证转化可用
      const exists = this.success_d.some((ret, i) => {
        index = i
        const idx = ret.convert_idx
        return !(ret.converter && ret.converter[idx].isExists)
      })
      if (exists) {
        this.$Message.warning('账号事件管理优化目标必须为可用')
        this.current = index
        return
      }
      // 写入本地存储
      const ac = this.success_d.map((ret) => ret.id)
      const ix = this.success_d.map((ret) => ret.convert_idx)
      const acix = {}
      ac.forEach((ret, i) => {
        acix[ret] = ix[i]
      })
      setLocal('converter', acix)
      // 提交转化
      setSession('ad_account_ids', this.success_d)
      setSession(
        'convert_params',
        this.success_d.map((ret) => {
          const idx = ret.convert_idx
          return Object.assign({}, ret.converter[idx], { platform: this.platform, gameId: this.gameId })
        })
      )
      this.$emit('on-complete')
    }
  },
  data() {
    return {
      show: null, // 请求状态
      app_id: '',
      current: 0,
      convert_type: 'AD_CONVERT_TYPE_ACTIVE', // 转化类型
      convert_source_type: 'AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD', // 转化来源
      deep_external_action: 0,
      btnSuccess: null, // 成功状态
      btnRetry: null, // 失败状态
      success_d: [] // 表格数据
    }
  },
  filters: {
    convType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE') return '激活'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '付费'
      else if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '注册'
      else if (cell === 'AD_CONVERT_TYPE_GAME_ADDICTION') return '关键行为'
      else if (cell === 'AD_CONVERT_TYPE_DOWNLOAD_START') return '完成下载'
      else if (cell === 'AD_CONVERT_TYPE_FORM') return '表单提交'
      else if (cell === 'AD_CONVERT_TYPE_WECHAT_WECOM_ADD') return '微信_添加企业微信'
      else if (cell === 'AD_CONVERT_TYPE_WECHAT_PAY') return '微信内付费'
      else if (cell === 'AD_CONVERT_TYPE_NOTIFY_FORM') return '预约表单'
      else if (cell === 'AD_CONVERT_TYPE_NOTIFY_DOWNLOAD') return '预约下载'
    },
    convDeepType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '，深度转化，注册'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '，深度转化，付费'
      else if (cell === 'AD_CONVERT_TYPE_PURCHASE_ROI') return '，深度转化，付费ROI'
      else if (cell === 'AD_CONVERT_TYPE_PURCHASE_ROI_7D') return '，深度转化，付费ROI-7日'
      else if (cell === 'AD_CONVERT_TYPE_NEXT_DAY_OPEN') return '，深度转化，次留'
      else if (cell === 'AD_CONVERT_TYPE_CLUE_CONFIRM') return '，深度转化，回访_信息确认'
      else if (cell === 'AD_CONVERT_TYPE_CLUE_INTERFLOW') return '，深度转化，回访_加为好友'
      else if (cell === 'AD_CONVERT_TYPE_CLUE_HIGH_INTENTION') return '，深度转化，回访_高潜成交'
      else return ''
      // else return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-convert {
  padding: 20px;
  min-height: 322px;

  .col-item {
    padding-top: 7px;
  }
}

.c-convert-table {
  width: 90%;
  margin: 0 auto;
  border: solid 1px #efefef;

  .c-table-thead {
    margin: 0;
    display: flex;
    height: 30px;
    line-height: 30px;
    border-bottom: solid 1px #efefef;
    background-color: #f8f8f9;

    dt {
      padding-left: 8px;
      color: #333;
      border-left: solid 1px #efefef;

      &:first-child {
        border-width: 0;
      }
    }
  }

  .c-convert-body {
    display: flex;
    max-height: 464px;

    .item-account,
    .item-group {
      display: inline-block;
    }

    .item-account {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      width: 25%;
      max-height: 364px;

      dd {
        width: 100%;
        min-height: 40px;
        line-height: 1.2;
        white-space: normal;
        word-break: break-all;
        padding: 6px 0 6px 8px;
        border-bottom: solid 1px #efefef;
        display: flex;
        align-items: center;

        &.on {
          color: #fff;
          background-color: #2b85e4;
        }
      }
    }

    .item-group {
      width: 75%;
      margin: 0;
      border-left: solid 1px #efefef;

      li {
        padding: 2px 0;
        border-bottom: solid 1px #efefef;

        &:last-child {
          border-width: 0;
        }
      }

      .item-group-dd {
        margin: 0;
        display: inline-block;
        width: 60%;
        padding-left: 8px;
        border-right: solid 1px #efefef;

        &:last-child {
          border-width: 0;
        }

        &.dd-child {
          width: 20%;

          a {
            margin-right: 6px;
          }
        }
      }
    }
  }
}

.c-convert-footer {
  padding: 0 12px;
  text-align: center;
}

.no-select-data {
  width: 300px;
  font-size: 12px;
  text-align: center;
  padding: 12px 20px;
}

.row-redio-group {
  overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 240px;

  .ivu-radio-wrapper {
    text-align: left;
  }
}

.item-span-info {
  display: inline-block;
  font-size: 12px;
  color: #ff4400;
  margin-top: 8px;
}
</style>
